// extracted by mini-css-extract-plugin
export default {"acceptfood_container":"Accept-food-fc_acceptfood_container__TDJkV","food_page":"Accept-food-fc_food_page__0xI1S"};